module.exports = __webpack_public_path__ + "static/airmason_branden-5682085a804a1b30dcf4175dfb52bda9.png";